export type MediaId = string;

export type Media = {
  id: MediaId;
  href: string;
};

// The kinds of media the API stores (`MediaType` in mindfeed-api).
export type MediaType = 'image' | 'video' | 'audio' | 'file';

// Smaller copies the server makes of an image (e.g. `sq_sm`, a small square).
export type MediaVariantName =
  'sq_sm' | 'sq_md' | 'sq_lg' | 'nat_sm' | 'nat_md' | 'nat_lg';

// A media file as returned by `GET /media?ids=…`, with signed CDN URLs that
// work in a plain <img>/<video> until `expiresAt`.
export type MediaAsset = {
  id: MediaId;
  fileName: string;
  mediaType: MediaType;
  mimeType: string;
  sizeBytes?: number | null;
  createdAt: string;
  // Missing for public media, whose URLs don't expire.
  expiresAt?: string | null;
  urls: {
    original: string;
    // Only present once the server has generated them.
    variants: Partial<
      Record<string, { url: string; fileName: string; mimeType: string }>
    >;
  };
};

/** The URL to show: the requested smaller copy if the server has made it. */
export const mediaUrl = (
  asset: MediaAsset,
  variant?: MediaVariantName,
): string =>
  (variant && asset.urls.variants[variant]?.url) || asset.urls.original;
